/* eslint-disable */
import * as React from "react"
import { spinner } from "./style.module.css"

const Spinner = props => (
  <span role="progressbar" className={spinner} {...props} />
)

export default Spinner
